import { useActionInput } from '../../../context';
import { Tag } from '../types';

export const useIsActive = (tag: Tag) => {
	const { state } = useActionInput();

	return !!state[`has${tag.slice(0, 1).toUpperCase() + tag.slice(1)}` as keyof typeof state];
};
